import { SetStateAction, useState } from "react";

import { Toast } from "@newsela/angelou";

import globalToasterRef from "@/base/globalToasterRef";
import { usePostContentFeedback } from "@/content/useContentFeedback";
import { ReportSource } from "@/view/constants/reportSources";

const useReportContent = () => {
  const [problemDescription, setProblemDescription] = useState("");
  const [postContentFeedback] = usePostContentFeedback();

  const handleCancelReport = () => {
    setProblemDescription("");
  };

  interface IHandleSubmitReport {
    contentId?: string;
    extraData?: Record<string, unknown> | undefined;
    reportSource?: ReportSource;
    reaction?: string;
  }

  const handleSubmitReport = async ({
    contentId,
    extraData,
    reaction,
    reportSource,
  }: IHandleSubmitReport) => {
    const { error } = await postContentFeedback({
      content_id: contentId,
      content_type:
        reportSource === "ChecksForUnderstanding"
          ? "CHECKS_FOR_UNDERSTANDING_QUIZ"
          : reportSource === "GuidedHighlightingQuestion"
            ? "guidedhighlightingquestion"
            : "generatedtextasset",
      extra_data: extraData,
      rationale: problemDescription,
      reaction: reaction || "flag",
    });

    const toastProps = error
      ? {
          statusColor: Toast.statusColor.danger,
          children: "Oops, something failed unexpectedly!",
        }
      : {
          statusColor: Toast.statusColor.success,
          children:
            reportSource === "GuidedHighlightingQuestion"
              ? "Thank you for the feedback!"
              : "Thank you for reporting a problem!",
        };

    globalToasterRef.current.displayToast({
      ...toastProps,
      showIcon: true,
    });

    if (!error) {
      setProblemDescription("");
    }
  };

  const handleTextAreaChange = (e: {
    target: { value: SetStateAction<string> };
  }) => setProblemDescription(e.target.value);

  return {
    handleCancelReport,
    handleSubmitReport,
    handleTextAreaChange,
    problemDescription,
  };
};

export default useReportContent;
